/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConsentTranscriptAliases {
  BUTTON_CLOSE_TRANSCRIPT_TEXTS = 'button-close-transcript-texts',
  BUTTON_DISCARD_TRANSCRIPT = 'button-discard-transcript',
  BUTTON_SAVE_TRANSCRIPT = 'button-save-transcript',
  BUTTON_SHOW_TRANSCRIPT_TEXTS = 'button-show-transcript-texts',
  GLOBAL_ACTIONS_TRANSCRIPT_TEXTS = 'global-actions-transcript-texts',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_CONSENT_TRANSCRIPT = 'layout-consent-transcript',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_CONTENT_RECORDING = 'layout-content-recording',
  LAYOUT_GLOBAL_BUTTONS = 'layout-global-buttons',
  MODAL_TRANSCRIPT_TEXTS = 'modal-transcript-texts',
  PANEL_BUTTON_DISCARD = 'panel-button-discard',
  PANEL_BUTTON_SAVE = 'panel-button-save',
  PANEL_CONENT = 'panel-conent',
  PANEL_CONSENT_TRANSCRIPT_CONTENT = 'panel-consent-transcript-content',
  PANEL_GLOBAL_ACTION_CONSENT_TRANSCRIPT = 'panel-global-action-consent-transcript',
  PANEL_INFORMATION_BAR_HEADER = 'panel-information-bar-header',
  PANEL_SHOW_TRANSCRIPT_TEXTS = 'panel-show-transcript-texts',
  PANEL_TITLE = 'panel-title',
  PANEL_TRANSCRIPT_RESULTS = 'panel-transcript-results',
  PANEL_TRANSCRIPT_TEXTS = 'panel-transcript-texts',
  TEXT_AREA_TRANSCRIPT_RESULTS = 'text-area-transcript-results',
  TEXT_STATUS = 'text-status',
  TEXT_SUBTITLE = 'text-subtitle',
  TEXT_TITLE = 'text-title',
  TIMER = 'timer',
  VA_BUTTON = 'va-button',
}
export { ConsentTranscriptAliases };
